export const formatPrice = (price) => {
    if (!price || price <= 0) return 'Price not available';
    return `₹${Number(price).toFixed(2)}`;
};
